module.exports = __webpack_public_path__ + "img/imgYLSYB(7).418ea906.png";